import type { CheckboxProps } from '../Form/Checkbox';

export const PAYMENT_NEW_ADDRESS_LABEL_COLOR = '#6C6C6C';

export const PAYMENT_NEW_ADDRESS_UNCHECKED_CHECKBOX_PROPS: Pick<
  CheckboxProps,
  'disableUncheckedHover' | 'unselectedBorderColor'
> = {
  disableUncheckedHover: true,
  unselectedBorderColor: PAYMENT_NEW_ADDRESS_LABEL_COLOR,
};
